
import { supabase } from '@/integrations/supabase/client';
import { dbLogger } from '../utils/dbLogger';

/**
 * Deletes a Slack integration
 */
export const deleteSlackIntegration = async (aiStaffId: string): Promise<boolean> => {
  try {
    dbLogger.info("Deleting Slack integration", { aiStaffId });
    
    const { error } = await supabase
      .from('slack_integrations')
      .delete()
      .eq('ai_staff_id', aiStaffId);
    
    if (error) {
      dbLogger.error("Error deleting Slack integration", error);
      throw new Error(`Failed to delete integration: ${error.message}`);
    }
    
    dbLogger.info("Successfully deleted Slack integration", { aiStaffId });
    
    return true;
  } catch (error) {
    dbLogger.error("Exception in deleteSlackIntegration", error);
    throw error;
  }
};
